export default __webpack_public_path__ + "media/zurb/img/work/work-case-study-thumbnail2-0f401122eeda3dfa2e222ba695336f06.png";